module.exports = __webpack_public_path__ + "img/text.0c937882.svg";